import { SelectBox } from 'components/select-box'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Link } from 'react-router-dom'

/**
 * @module settings/settings-select-box
 * @description A multi-select settings field (grades taught, subjects
 * taught): click "Edit" to expand the picker, clicking away collapses it
 * and fires onBlur to save.
 */
export const SettingsSelectBox = ({
	label,
	name,
	options,
	selected,
	onChange,
	onBlur,
}) => {
	const selectBoxRef = useRef()
	const [ expand, setExpand ] = useState()

	const handleClickAway = useCallback((e) => {
		if (selectBoxRef.current?.contains(e.target)) return

		setExpand(false)

	}, [])

	useEffect(() => {
		expand
			? document.addEventListener('click', handleClickAway)
			: document.removeEventListener('click', handleClickAway)

		if (expand !== false) return

		onBlur && onBlur(name, selected)
	}, [expand])

	return (
		<div className="settings-item" ref={selectBoxRef}>
			<div className="field-label-container">
				<span className="field-label">{label}</span>
				<Link
					className="edit-link"
					onClick={() => setExpand(true)}
				>
					Edit
				</Link>
			</div>
			<SelectBox
				name={name}
				expand={expand}
				options={options}
				selected={selected}
				onChange={onChange}
			/>
		</div>
	)
}

export default SettingsSelectBox
